import { useEffect } from "react";
import { useRedirect } from "react-admin";

const EcobalyseList = () => {
  const redirect = useRedirect();

  useEffect(() => {
    // Redirigir automáticamente a la vista show con un ID dummy
    // porque queremos mostrar las tabs directamente
    redirect('/ecobalyse/main/show');
  }, [redirect]);

  return null;
};

export default EcobalyseList;
